import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import Select from 'react-select';
import { required, email, composeValidators} from '../../../forms';
import PhoneInput, { formatPhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import flags from 'react-phone-number-input/flags';

export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    {label && <ControlLabel>{label}</ControlLabel>}
    <FormControl {...input} type={type} />
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className="alert alert-warning">{warning}</p>))}
  </InputGroup>
);
export const renderField = ({ input, label, type }) => (
  <InputGroup>
    {label && <ControlLabel>{label}</ControlLabel>}
    <FormControl {...input} type={type} />
  </InputGroup>
);
export const customPhoneInput = ({ input, label, type, country}) => (
  <InputGroup>
  {label && <ControlLabel>{label}</ControlLabel>}
  <PhoneInput flags={flags} international {...input} type={type} country={country}/>
  </InputGroup>
);
const RenderSelectInput = ({ input, options, name, id, label, meta: { touched, error } }) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <Select
      id={id}
      name={name}
      options={options}
      value={input.value}
      onChange={value => input.onChange(value.value)}
      onBlur={value => input.onBlur(value.value)}
    />
    {touched &&
        ((error && <p className="alert alert-danger">{error}</p>))}
  </FormGroup>
);

const MemberDetailForm = ({ onSubmit, initialValues, groups, handleRemove, isNew,isParticipantGrid}) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={values => {
      const errors = {};
      if(!values.group){
        errors.group = 'Please select group.';
      }
     return errors;
    }}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => {
      const canDelete = !isNew;
      const isShow = !isParticipantGrid
      const saveLabel = isNew ? 'Add Member' : 'Edit Member';
      return (
        <div>
          <form onSubmit={handleSubmit}>
            <FormGroup>
              <Field
                name="first_name"
                type="text"
                component={renderBootstrapField}
                label="First Name"
                validate={required}
              />
              <Field
                name="last_name"
                type="text"
                component={renderBootstrapField}
                label="Last Name"
                validate={required}
              />
              <Field
                name="title"
                type="text"
                component={renderField}
                label="Title"
              />
            </FormGroup>
            <FormGroup>
              <Field
                name="group"
                type="text"
                component={RenderSelectInput}
                label="Group"
                options={groups}
              />
            </FormGroup>
            <FormGroup>
              <Field
                name="email"
                type="text"
                component={renderBootstrapField}
                label="Email"
                validate={composeValidators(email)}
              />
               {/* <Field
                name="phone_number"
                type="text"
                component={renderBootstrapField}
                label="Phone"
              /> */}
              <Field
                name="phone_number"
                type="text"
                country="US"
                component={customPhoneInput}
                label="Phone (Please select a Country and provide Phone Number)"
                placeholder="Enter phone number"
                 />
              {/*  error={ initialValues.phone_number ? (isValidPhoneNumber(initialValues.phone_number) ? undefined : 'Invalid phone number') : 'Phone number required' }/>
               <PhoneInput
                country="US"
                placeholder="Enter phone number"
                value={ initialValues.phone_number}
                onChange={ value => updatePhone(value) }/> */}
                
                
            </FormGroup>
            <FormGroup>
              <ButtonToolbar>
                <Button disabled={pristine || submitting} bsStyle="info" type="submit">
                  <i className="fa fa-pencil fa-lg" /> {saveLabel}
                </Button>
                {canDelete && isShow && (
                  <Button bsStyle="info" onClick={handleRemove}>
                    <i className="fa fa-trash fa-lg" /> Remove from Tour
                  </Button>
                )}
              </ButtonToolbar>
            </FormGroup>
          </form>
        </div>
      );
    }}
  />
);

export default MemberDetailForm;


// WEBPACK FOOTER //
// src/routes/tours/components/MemberDetailForm.js